import { createPortal } from 'react-dom';

export const MODAL_CONTAINER_ID = 'modal-container';

const ModalPortal = ({ show, children }: { show: boolean; children?: React.ReactNode }) => {
  const modalContainerEl = document.querySelector(`#${MODAL_CONTAINER_ID}`);

  if (modalContainerEl) {
    return createPortal(<>{show && children}</>, modalContainerEl);
  }

  return <></>;
};

export default ModalPortal;
